import { DataModuleVO, DataVO } from '@edgvr-front/data/domain';

export class DataModuleSummaryStatCsvDMO {
  readonly data: string;

  constructor(data: DataVO, dataModule: DataModuleVO) {
    const header = [
      'Account Name',
      'Center Name',
      'Candidate First Name',
      'Candidate Middle Name',
      'Candidate Last Name',
      'Candidate DOB',
      'Workshop Name',
      'Total Score',
      'Score Percentage',
      'Start Date/Time',
      'Finish Date/Time',
      'Date Of Entry',
    ]
      .map((_) => (_.includes(',') ? `"${_}"` : _))
      .join(',');

    const rows = dataModule.persons.map((_) =>
      [
        data.accountName,
        data.centerName || '',
        _.firstName,
        _.middleName || '',
        _.lastName,
        new Date(_.dateOfBirth).toLocaleDateString('en-GB'),
        data.workshopName,
        _.score + '',
        ((_.score * 100) / dataModule.maxScore).toFixed(2),
        new Date(data.startedAt).toLocaleString('en-GB'),
        new Date(data.finishedAt).toLocaleString('en-GB'),
        new Date(data.entryAt).toLocaleString('en-GB'),
      ]
        .map((_) => (_.includes(',') ? `"${_}"` : _))
        .join(',')
    );

    this.data = [header, ...rows].join('\n');
  }
}
